import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_TRIALPERSONNEL_LOAD_BY_ID,
    ACTION_TRIALPERSONNELS_LOAD_BY_PERSONNEL_ID,
    ACTION_TRIALPERSONNELS_LOAD_BY_TRIAL_ID,
    ACTION_TRIALPERSONNELS_LOAD_BY_TRIALINSTITUTION_ID,
    ACTION_TRIALPERSONNELS_LOAD_BY_TRIALGROUP_ID,
    ACTION_TRIALPERSONNELS_LOAD_BY_GROUP_ID,
    ACTION_TRIALPERSONNEL_LOAD_FAILURE,
    ACTION_TRIALPERSONNEL_LOAD_SUCCESS,

    ACTION_TRIALPERSONNEL_SAVE,
    ACTION_TRIALPERSONNEL_SAVE_SUCCESS,
    ACTION_TRIALPERSONNEL_SAVE_FAILURE,

    ACTION_TRIALPERSONNEL_CREATE,
    ACTION_TRIALPERSONNEL_CREATE_SUCCESS,
    ACTION_TRIALPERSONNEL_CREATE_FAILURE,

    ACTION_TRIALPERSONNEL_VALIDATE,
    ACTION_TRIALPERSONNEL_VALIDATE_SUCCESS,
    ACTION_TRIALPERSONNEL_VALIDATE_FAILURE,


    ACTION_TRIALPERSONNEL_CLEAR,
    TrialPersonnelAction,
    ACTION_TRIALPERSONNELS_LOAD_BY_INSTITUTION_ID,
} from '../actions/trialPersonnel';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialPersonnelState {
    formData: Dtos.TrialPersonnel | Dtos.TrialPersonnel[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
}

const initialState: ITrialPersonnelState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState
};


function loading(state: ITrialPersonnelState, _isLoading: boolean): ITrialPersonnelState {
    const newState: ITrialPersonnelState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: ITrialPersonnelState,
    formData: Dtos.TrialPersonnel | Dtos.TrialPersonnel[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialPersonnelState {
    const newState: ITrialPersonnelState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function loadFailure(state: ITrialPersonnelState, responseStatus: Dtos.ResponseStatus): ITrialPersonnelState {
    const newState: ITrialPersonnelState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: ITrialPersonnelState, propertiesToClear?: string[]): ITrialPersonnelState {

    if (!propertiesToClear) {
        const newState: ITrialPersonnelState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: ITrialPersonnelState, _isSaving: boolean): ITrialPersonnelState {
    const newState: ITrialPersonnelState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ITrialPersonnelState,
    formData: Dtos.TrialPersonnel | Dtos.TrialPersonnel[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialPersonnelState {
    const newState: ITrialPersonnelState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ITrialPersonnelState, responseStatus: Dtos.ResponseStatus): ITrialPersonnelState {
    const newState: ITrialPersonnelState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ITrialPersonnelState, _isCreating: boolean): ITrialPersonnelState {
    const newState: ITrialPersonnelState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ITrialPersonnelState,
    formData: Dtos.TrialPersonnel,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ITrialPersonnelState {
    const newState: ITrialPersonnelState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ITrialPersonnelState, responseStatus: Dtos.ResponseStatus): ITrialPersonnelState {
    const newState: ITrialPersonnelState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: ITrialPersonnelState, _isValidating: boolean): ITrialPersonnelState {
    const newState: ITrialPersonnelState = update(state, {
        validatingState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: ITrialPersonnelState,
    formData: Dtos.TrialPersonnel,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialPersonnelState {
    const newState: ITrialPersonnelState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: ITrialPersonnelState, responseStatus: Dtos.ResponseStatus): ITrialPersonnelState {
    const newState: ITrialPersonnelState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const TrialPersonnelReducer: Reducer<ITrialPersonnelState> = (state: ITrialPersonnelState = initialState, action: TrialPersonnelAction) => {
    switch (action.type) {
        case ACTION_TRIALPERSONNEL_LOAD_BY_ID:
        case ACTION_TRIALPERSONNELS_LOAD_BY_PERSONNEL_ID:
        case ACTION_TRIALPERSONNELS_LOAD_BY_TRIAL_ID:
        case ACTION_TRIALPERSONNELS_LOAD_BY_INSTITUTION_ID:
        case ACTION_TRIALPERSONNELS_LOAD_BY_TRIALINSTITUTION_ID:
        case ACTION_TRIALPERSONNELS_LOAD_BY_TRIALGROUP_ID:
        case ACTION_TRIALPERSONNELS_LOAD_BY_GROUP_ID:
            return loading(state, true);
        case ACTION_TRIALPERSONNEL_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALPERSONNEL_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALPERSONNEL_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALPERSONNEL_SAVE:
            return saving(state, true);
        case ACTION_TRIALPERSONNEL_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALPERSONNEL_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_TRIALPERSONNEL_CREATE:
            return creating(state, true);
        case ACTION_TRIALPERSONNEL_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_TRIALPERSONNEL_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_TRIALPERSONNEL_VALIDATE:
            return validating(state, true);
        case ACTION_TRIALPERSONNEL_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALPERSONNEL_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
    }

    return state;
}

export default TrialPersonnelReducer;